import React from 'react'

const AppConext = React.createContext({})
export default AppConext;